import React from 'react';

export default function EmElaboracao({ title, description, icon = '🚧', section }) {
  return (
    <div style={{ padding: '48px 32px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 420 }}>
      <div style={{ fontSize: 56, marginBottom: 16 }}>{icon}</div>
      <div style={{
        display: 'inline-block', background: '#fef9c3', color: '#a16207',
        padding: '4px 14px', borderRadius: 20, fontSize: '0.72rem', fontWeight: 700,
        textTransform: 'uppercase', letterSpacing: .6, marginBottom: 14,
      }}>Em elaboração</div>
      <div style={{ fontWeight: 800, fontSize: '1.3rem', color: '#1e293b', marginBottom: 8, textAlign: 'center' }}>{title}</div>
      {description && (
        <div style={{ color: '#64748b', fontSize: '0.88rem', textAlign: 'center', maxWidth: 480, lineHeight: 1.6 }}>{description}</div>
      )}
      {section && (
        <div style={{ marginTop: 24, color: '#94a3b8', fontSize: '0.75rem' }}>Seção: {section}</div>
      )}
    </div>
  );
}
